import { render } from "./top-bar.vue?vue&type=template&id=4e5efc8c&scoped=true"
import script from "./top-bar.vue?vue&type=script&lang=js"
export * from "./top-bar.vue?vue&type=script&lang=js"

import "./top-bar.vue?vue&type=style&index=0&id=4e5efc8c&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5efc8c"]])

export default __exports__